// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jwRl","name":"styles_name__bn-Di","phone":"styles_phone__i4byJ"};